import { render, staticRenderFns } from "./PartnerUserRoles.vue?vue&type=template&id=f246b56a&"
import script from "./PartnerUserRoles.vue?vue&type=script&lang=ts&"
export * from "./PartnerUserRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports